import BlobCacheService from './BlobCacheService';

export const blobCacheService = new BlobCacheService();
